import BaseService from "@/services/Base-service";

class AddressService {
  get controllerName() { return '/Address/'; }

  getCountries() {
    return BaseService.get(this.controllerName + 'GetCountries');
  }

  getProvincesByCountry(countryId) {
    return BaseService.get(this.controllerName + 'GetProvinces/' + countryId);
  }

  getCountiesByProvince(provinceId) {
    return BaseService.get(this.controllerName + 'GetCounties/' + provinceId);
  }
}
export default new AddressService();